<script setup>
import { ref, watch } from 'vue'

const emit = defineEmits(['close'])

// TODO verificar esse padrão
const value = defineModel({ type: String })

defineProps({
  right: {
    type: Boolean,
    default: true,
  },
  dimmer: {
    type: Boolean,
    default: true,
  },
  size: {
    type: String,
    default: 'sm',
    validators: value => ['sm', 'md', 'lg'].includes(value),
  },
  title: {
    type: String,
    default: 'Painel Lateral',
  },
  subtitle: {
    type: String,
    default: '',
  },
})

const isContentVisible = ref(false)

const close = () => {
  emit('close')
}

watch(value, newVal => {
  if (!newVal) {
    isContentVisible.value = false // Esconde o conteúdo quando o painel é fechado
  } else {
    isContentVisible.value = true // Exibe o conteúdo quando o painel é aberto
  }
})
</script>

<template>
  <div id="sidepanel">
    <!--Sidepanel com tomada de contexto -->
    <div class="inset-0 z-40 flex" :class="{ fixed: value, 'pointer-events-none': !value }">
      <!-- Sidebar -->
      <div
        class="pointer-events-none absolute bottom-0 z-20 flex h-screen items-end"
        :class="[
          'inset-x-0 sm:pointer-events-auto sm:inset-x-auto sm:top-0 sm:h-auto sm:w-auto sm:flex-row sm:items-start',
          right ? 'sm:right-0' : 'sm:left-0 sm:flex-row-reverse',
        ]"
      >
        <div
          ref="content"
          class="pointer-events-auto flex flex-col overflow-hidden bg-white drop-shadow-lg transition-all duration-700"
          :class="{
            'h-[90vh] translate-y-full sm:h-full sm:w-0 sm:max-w-0 sm:translate-y-0': !value,
            'h-[90vh] w-full translate-y-0 rounded-t-[16px] sm:h-full sm:w-[520px] sm:max-w-[520px] sm:rounded-t-none':
              value && size === 'sm',
            'h-[90vh] w-full translate-y-0 rounded-t-[16px] sm:h-full sm:w-[690px] sm:max-w-[680px] sm:rounded-t-none':
              value && size === 'md',
            'h-[90vh] w-full translate-y-0 rounded-t-[16px] sm:h-full sm:w-[770px] sm:max-w-[760px] sm:rounded-t-none':
              value && size === 'lg',
            'sm:rounded-l-[16px]': right,
            'sm:rounded-r-[16px]': !right,
          }"
        >
          <div v-if="isContentVisible" class="flex h-full overflow-auto">
            <slot :name="value" />
          </div>
          <div v-else class="flex h-full items-center justify-center overflow-auto">
            <div class="loader" />
          </div>
        </div>
      </div>

      <transition name="fade">
        <!-- Escurece a tela por trás -->
        <div
          v-if="dimmer && value"
          @click="close()"
          class="absolute inset-0 z-15 bg-gray-400/75 backdrop-blur-sm active:outline-hidden"
        />
      </transition>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* .loader {
  @apply border-4 border-primary-20 border-l-primary-90 rounded-full w-9 h-9;
  animation: spin 1s linear infinite;
} */

/* @keyframes spin {
  100% {
    transform: rotate(360deg);
  }
} */
</style>
